import React from "react";
import PT from "prop-types";
import StoryHeader from "../story-header";
import useUrl from "../../../hook/useUrl";
import SideBar from "../../molecules/sidebar";
import { Readpeak } from "../../atoms/readpeak";
import { Suurtaulu } from "../../atoms/suurtaulu";
import { SocialShare } from "@quintype/components";
import useSocialShareLinks from "../../../hook/useSocialShareLinks";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryPaywallComponent from "../../atoms/paywalls/story-paywall-component";
import "./blank.m.css";
import { IppeTop } from "../../atoms/ippe-top";
import { VaasaTulospalveluTop } from "../../atoms/vaasa-tulospalvelu-top";

const BlankStory = ({ story }) => {
  const [_, currentUrlSlug] = useUrl();
  let domainSlug = ""
  if (currentUrlSlug === "vaasalehti") {
    domainSlug = "vaasa"
  }
  else if (currentUrlSlug === "epari") {
    domainSlug = "epari"
  }
  else {
    domainSlug = "ilkka-pohjalainen"
  }
  const socialShareLinks = useSocialShareLinks(story, domainSlug);
  const metakeywords = story.seo["meta-keywords"];
  const hashtags = metakeywords
    ? metakeywords.map(item => {
      return item.replace(/ /g, "");
    })
    : "";
  const storySections = story.sections;
  var section;
  var slug;
  if (storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen") || []) {
    section = storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen") || [];
  } else if (storySections.find(section => section["domain-slug"] !== "undefined")) {
    section = story.sections[0];
  }

  /* checks if article is ippe article. Then use urheilu list on suosituimmat */
  var sportCollection = (section.collection && section.collection.slug && section.collection.slug.includes("ippe")) ? "urheilu" : ""
  if (section.collection === undefined) {
    slug = "";
  } else if (sportCollection !== "" && sportCollection !== undefined) {
    slug = "urheilu-ilkka-pohjalainen";
  } // else {
  //  slug = "section.collection.slug";
  // }

  const renderTopComponent = () => {
    if (section && section.collection && section.collection.slug && section.collection.slug.includes("ippe")) {
      if (currentUrlSlug === "vaasalehti") {
        return <VaasaTulospalveluTop slug={section.collection.slug} />;
      }
      return <IppeTop slug={section.collection.slug} />;
    }
    return null; // Render nothing if the conditions are not met
  };


  return (
    <React.Fragment>
      <div styleName={`top-container ${(sportCollection && section.collection.slug && sportCollection !== "") ? "ippe-article" : ""}`}>
        <div styleName="main-container" className={`${(sportCollection && currentUrlSlug === "vaasalehti") ? "ippe-vaasa" : ""}`}>
          <div styleName="main">
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_63333" data-placement-id="paraatipaikka-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_63219" data-placement-id="paraatipaikka-desktop"></div>
              </div>
            </div>
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_112313" data-placement-id="paraatipaikka-2-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_112312" data-placement-id="paraatipaikka-2-desktop"></div>
              </div>
            </div>
          </div>
          {renderTopComponent()}
          <div styleName="blank-story">
            <div styleName="sticky-social-share">
              <SocialShare
                template={StickySocialShareTemplate}
                story={story}
                title={story.headline}
                fullUrl={socialShareLinks}
                hashtags={story.seo["meta-keywords"] ? hashtags.join(",") : ""}
                color="#000"
                sticky
              />
            </div>
            <div className="voice-article" styleName="story-container">
              {section && section.collection && section.collection.slug.includes("kiekko-ippe") &&
                <div styleName={`ippe-title ${currentUrlSlug === "vaasalehti" ? "ippe-title-vaasa" : ""}`}>
                  Kiekko-Ippe
                </div>
              }
              {section && section.collection && section.collection.slug.includes("pesis-ippe") &&
                <div styleName={`ippe-title ${currentUrlSlug === "vaasalehti" ? "ippe-title-vaasa" : ""}`}>
                  Pesis-Ippe
                </div>}
              {section && section.collection && section.collection.slug.includes("salibandy-ippe") &&
                <div styleName={`ippe-title ${currentUrlSlug === "vaasalehti" ? "ippe-title-vaasa" : ""}`}>
                  Salibandy-Ippe
                </div>}
                {section && section.collection && section.collection.slug.includes("futis-ippe") &&
                <div styleName={`ippe-title ${currentUrlSlug === "vaasalehti" ? "ippe-title-vaasa" : ""}`}>
                  Futis-Ippe
                </div>}
              <div styleName="story-header">
                <StoryHeader story={story} />
              </div>
              <StoryPaywallComponent story={story} showAds={true} />
              <div styleName="readpeak-widget">
                <Readpeak />
              </div>
            </div>
            <SideBar useCollection={slug} pageType={"story"} />
          </div>
        </div>
        <Suurtaulu />
      </div>
    </React.Fragment>
  );
};

BlankStory.propTypes = {
  story: PT.object,
  isActive: PT.bool
};

export { BlankStory };
